import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useLearning } from 'src/hook/data/useLearning';
import { WordList } from 'src/model/WordList';
import { IconLocation } from 'src/utils/URLUtils';
import styles from './WordListSection.module.scss';

export const WordListSection = () => {
    const { learningInfo } = useLearning();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();

    const handleClick = (wordList: WordList) => {
        navigate(`/wordlists/${wordList.IsCompleted ? 'wordlist' : 'discover'}?id=${wordList.ID}`);
    }

    return (
        <section className={styles.wordListSection}>
            <h2 className='homeTitle'>{t('Word Lists')}</h2>
            <p dir={i18n.dir()} className='homeSubtitle'>{t('Focus on specific topics you need to master today.')}</p>

            <div className={styles.grid}>
                {learningInfo?.WordLists.slice(0, 7).map((wordList: WordList, index: number) => (
                    <div key={index}
                        onClick={() => handleClick(wordList)}
                        className={styles.card}>
                        <img src={wordList.ImageUrl} alt={t(wordList.Title)} />
                        <span>{wordList.Title === '1500 Essential Words' ? '1500' : t(wordList.Title)}</span>
                    </div>
                ))}
                <div className={styles.card}
                    onClick={() => navigate('/wordlists')}>
                    <img src={IconLocation('celeb-more')} alt={t('More')} />
                    <span>{t('More')}</span>
                </div>
            </div>
        </section>
    );
};
